import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="rcs-footer">
      <p>© {new Date().getFullYear()} RCS Management. All intellectual rights reserved. All trademarks, registered names,slogans and logos used in this site, are copyright to thier respective company</p>
    </footer>
  );
};

export default Footer;
